var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67049 20.2238V10.7929H0L12 0L17.8168 5.1389V1.79649H20.3295V7.46779L24 10.7804H20.3295V20.2238H13.3961V13.1929H10.6039V20.2238H3.67049ZM5.5938 18.3005H8.68063V11.2626H15.3194V18.3005H18.4062V8.36349L12 2.54671L5.5938 8.36555V18.3005ZM9.45264 8.19692H14.5474C14.5474 7.53444 14.2937 6.98494 13.7863 6.54843C13.2789 6.1119 12.6838 5.89364 12.001 5.89364C11.3182 5.89364 10.7228 6.11035 10.2147 6.54378C9.70667 6.9772 9.45264 7.52825 9.45264 8.19692Z",
    fill: "#1B544F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/Address.d196d56f4213797bf6a1e55b84c9f971.svg";
export { ForwardRef as ReactComponent };